import * as React from 'react';

/** Material UI Packages. */
import { Tooltip, Typography } from '@mui/material';
import { GridActionsCellItem } from '@mui/x-data-grid-pro';

/** Material UI Icons. */
import BorderColorIcon from '@mui/icons-material/BorderColor';
import DownloadIcon from '@mui/icons-material/Download';
import DeleteIcon from '@mui/icons-material/Delete';

/** Internal Components. */
import { guideCategory } from 'shared/config/constantsData';
import { customized_style } from 'shared/config/Styles';
import { formatOperationDateTime } from 'shared/lib/dateFormatter';

export const getGuidelineCol = (handleDownload, handleEdit, handleDelete) => [
    {
        field: 'id',
        headerName: 'ID',
        align: 'center',
        headerAlign: 'center',
    },
    {
        field: 'il_category_id',
        headerName: 'Category',
        type: 'singleSelect',
        align: 'center',
        headerAlign: 'center',
        flex: 0.4,
        valueGetter: (params) => {
            const category = guideCategory.find((category) => category.id === params);
            return category ? category.content : 'Unknown';
        },
    },
    {
        field: 'title',
        headerName: 'Subject',
        align: 'center',
        headerAlign: 'center',
        flex: 2.0,
    },
    {
        field: 'il_file_url',
        headerName: 'Files',
        align: 'center',
        headerAlign: 'center',
        flex: 0.1,
        type: 'actions',
        getActions: ({ row }) => {
            return [
                <Tooltip title="Download">
                    <GridActionsCellItem
                        component="span"
                        sx={{
                            bgcolor: '#003a52',
                            color: 'white',
                            '&:hover': { color: '#003a52' },
                            p: '5px',
                        }}
                        icon={<DownloadIcon sx={{ fontSize: '13px' }} />}
                        onClick={() => handleDownload(row)}
                        disabled={row.il_guideline_file === null}
                        label="Download"
                        color="inherit"
                    />
                </Tooltip>,
            ];
        },
    },
    {
        field: 'il_user_id',
        headerName: 'Modified By',
        align: 'center',
        headerAlign: 'center',
        flex: 0.3,
    },
    {
        field: 'modified_on',
        headerName: 'Modified On',
        align: 'center',
        headerAlign: 'center',
        flex: 0.3,
        valueGetter: (params) => {
            if (params == null) return null;
            // 수정 시점을 근무지(LA) 날짜로 보여줘, 한국에서 열어도 같은 날짜로 검색된다.
            return formatOperationDateTime(params, 'MM/DD/YY') || null;
        },
        renderCell: (params) => {
            if (params.value != null) {
                return <Typography sx={customized_style.itemDatagrid_Typography}>{params.value}</Typography>;
            } else return null;
        },
    },
    {
        field: 'actions',
        headerName: 'Actions',
        align: 'center',
        headerAlign: 'center',
        type: 'actions',
        getActions: ({ row }) => {
            return [
                <Tooltip title="Edit" key="edit">
                    <GridActionsCellItem
                        sx={{
                            bgcolor: '#003a52',
                            color: 'white',
                            '&:hover': { color: '#003a52' },
                            p: '5px',
                        }}
                        icon={<BorderColorIcon sx={{ fontSize: '13px' }} />}
                        label="Edit"
                        onClick={() => {
                            handleEdit(row.id);
                        }}
                        color="inherit"
                    />
                </Tooltip>,
                <Tooltip title="Delete" key="delete">
                    <GridActionsCellItem
                        sx={{
                            bgcolor: '#003a52',
                            color: 'white',
                            '&:hover': { color: '#003a52' },
                            p: '5px',
                        }}
                        icon={<DeleteIcon sx={{ fontSize: '13px' }} />}
                        label="Delete"
                        onClick={() => handleDelete(row.id)}
                        color="inherit"
                    />
                </Tooltip>,
            ];
        },
    },
];
export default getGuidelineCol;
